import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { JobstatusComponent } from './jobstatus/jobstatus.component';
import { AdjustmentInquiryComponent } from './adjustment-inquiry/adjustment-inquiry.component';
import { OrderforecastComponent } from './orderforecast/orderforecast.component';
import { MasterSetupComponent } from './master-setup/master-setup.component';
import { MsalGuard } from './msal';
import { RunDownMaintenanceComponent } from './run-down-maintenance/run-down-maintenance.component';
import { BulkAdjustmentComponent } from './bulk-adjustment/bulk-adjustment.component';
import { ReportsComponent } from './reports/reports.component';
import { FluctuationAllowanceMaintenanceComponent } from './fluctuation-allowance-maintenance/fluctuation-allowance-maintenance.component';
import { CalenderSetupComponent } from './calender-setup/calender-setup.component';
import { ContactComponent } from './contact/contact.component';
import { GetSudoStatusComponent } from './get-sudo-status/get-sudo-status.component';
import { FaqComponent } from './faq/faq.component';
import { CanDeactivateGuard } from './can-deactivate.guard';
import { TrainingVideosComponent } from './training-videos/training-videos.component';
import { ReleaseNotesComponent } from './release-notes/release-notes.component';
import { PipeJobstatusComponent } from './pipe-jobstatus/pipe-jobstatus.component';
import { PipeReportsComponent } from './pipe-reports/pipe-reports.component';
import { PartsinquireComponent } from './partsinquire/partsinquire.component';
import { PartMaintenanceComponent } from './part-maintenance/part-maintenance.component';
import { ContainerMaintenanceComponent } from './container-maintenance/container-maintenance.component';
import { SealVerificationComponent } from './seal-verification/seal-verification.component';
import { RoleGuard } from './msal/roles.guard';
import { PipeRelasenotesComponent } from './pipe-relasenotes/pipe-relasenotes.component';
import { AirFreightOrderComponent } from './air-freight-order/air-freight-order.component';
import { AddEditAirRecordComponent } from './air-freight-order/add-edit-air-record/add-edit-air-record.component';
import { EditFormComponent } from './air-freight-order/add-edit-air-record/edit-form/edit-form.component';
import { StockingPaceInquiryComponent } from './stocking-pace-inquiry/stocking-pace-inquiry.component';
import { StockingPaceMaintenanceComponent } from './stocking-pace-maintenance/stocking-pace-maintenance.component';
import { ContainerOrderingComponent } from './container-ordering/container-ordering.component';
import { ModuleTypeComponent } from './module-type/module-type.component';
import { ShiftConfigurationComponent } from './configuration-shifts/configuration-shifts.component';

import { ProductionProgressComponent } from './production-progress/production-progress.component';

import { ModuleStockingDevanningComponent } from './module-stocking-devanning/module-stocking-devanning.component';
import { UsageVsReceiptComponent } from './usage-vs-receipt/usage-vs-receipt.component';
import { PartsCountComponent } from './parts-count/parts-count.component';
import { PartsGroupComponent } from './parts-count/parts-group/parts-group.component';
import { ContainerTapComponent } from './container-tap/container-tap.component';
import { ConfigurationPartsComponent } from './configuration-parts/configuration-parts.component';
import { ProcurementComponent } from './procurement/procurement.component';
import { DevanHistoryComponent } from './devan-history/devan-history.component';
import { LlpJobstatusComponent } from './llp-jobstatus/llp-jobstatus.component';
import { LlpReportsComponent } from './llp-reports/llp-reports.component';
import { InvRolesGuard } from './msal/invroles.guard';
import { OsInvReleaseNotesComponent } from './os-Inventory-releasenotes/os-inv-release-notes.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';


const pipeRoles = ['OSPIPE.READONLY', 'OSPIPE.ADMIN', 'OSPIPE.NAMCADMIN', 'OSPIPE.FLUSER',
'OS.INV.FLOORUSER-QA','OS.INV.FLOORUSER'];

const routes: Routes = [
  { path: '', component: HomeComponent, canActivate: [MsalGuard] },
  { path: 'dashboard', component: HomeComponent, canActivate: [MsalGuard] },
  {
    path: 'ordering/jobstatus',
    component: JobstatusComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'ordering/adjustmentinquiry',
    component: AdjustmentInquiryComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'ordering/orderforecast',
    component: OrderforecastComponent,
    canActivate: [MsalGuard],
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: 'setup/master',
    component: MasterSetupComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'ordering/rundownmaintenance',
    component: RunDownMaintenanceComponent,
    canActivate: [MsalGuard],
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: 'ordering/bulkadjustment',
    component: BulkAdjustmentComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'ordering/reports',
    component: ReportsComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'ordering/famaintenance',
    component: FluctuationAllowanceMaintenanceComponent,
    canActivate: [MsalGuard],
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: 'ordering/getsudostatus',
    component: GetSudoStatusComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'setup/calendar',
    component: CalenderSetupComponent,
    canActivate: [MsalGuard],
    canDeactivate: [CanDeactivateGuard],
  },
  { path: 'contact', component: ContactComponent, canActivate: [MsalGuard] },
  { path: 'faq', component: FaqComponent, canActivate: [MsalGuard] },
  {
    path: 'help/trainingvideos',
    component: TrainingVideosComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'help/releasenotes',
    component: ReleaseNotesComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'help/osInventoryreleasenotes',
    component: OsInvReleaseNotesComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'help/pipereleasenotes',
    component: PipeRelasenotesComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'pipe/jobstatus',
    component: PipeJobstatusComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'pipe/partsinquire',
    component: PartsinquireComponent,
    data: {
      roles: pipeRoles,
    },
    canActivate: [MsalGuard, RoleGuard],
    // canActivate: [MsalGuard],
    // canDeactivate: [CanDeactivateGuard],
  },
  {
    path: 'pipe/partsmaintenance',
    component: PartMaintenanceComponent,
    data: {
      roles: pipeRoles,
    },
    canActivate: [MsalGuard, RoleGuard],
  },
  {
    path: 'pipe/containermaintenance',
    component: ContainerMaintenanceComponent,
    data: {
      roles: pipeRoles,
    },
    canActivate: [MsalGuard, RoleGuard],
  },
  {
    path: 'pipe/sealverification',
    component: SealVerificationComponent,
    data: {
      roles: ['OSPIPE.READONLY', 'OSPIPE.ADMIN', 'OSPIPE.NAMCADMIN', 'OSPIPE.LP', 'OSPIPE.SECUSER'],
    },
    canActivate: [MsalGuard, RoleGuard],
  },
  {
    path: 'inventory/productionprogress',
    component: ProductionProgressComponent,
    canActivate: [MsalGuard, InvRolesGuard],
  },
  {
    path: 'inventory/Procurement',
    component: ProcurementComponent,
    canActivate: [MsalGuard, InvRolesGuard],
  },
  {
    path: 'inventory/jobstatus',
    component: LlpJobstatusComponent,
    canActivate: [MsalGuard, InvRolesGuard],
  },
  {
    path: 'inventory/reports',
    component: LlpReportsComponent,
    canActivate: [MsalGuard, InvRolesGuard],
  },
  {
    path: 'inventory/usagevsreceipt',
    component: UsageVsReceiptComponent,
    canActivate: [MsalGuard, InvRolesGuard],
  },
  {
    path: 'pipe/jobstatus',
    component: PipeJobstatusComponent,
    data: {
      roles: pipeRoles,
    },
    canActivate: [MsalGuard, RoleGuard],
  },
  {
    path: 'pipe/reports',
    component: PipeReportsComponent,
    data: {
      roles: pipeRoles,
    },
    canActivate: [MsalGuard, RoleGuard],
  },
  {
    path: 'ordering/airfreightorder',
    component: AirFreightOrderComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'inventory/stocking-pace-inquiry',
    component: StockingPaceInquiryComponent,
    canActivate: [MsalGuard, InvRolesGuard],
  },
  {
    path: 'inventory/stocking-pace-maintenance',
    component: StockingPaceMaintenanceComponent,
    canActivate: [MsalGuard, InvRolesGuard],
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: 'setup/module-type',
    component: ModuleTypeComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'inventory/container-ordering',
    component: ContainerOrderingComponent,
    canActivate: [MsalGuard, InvRolesGuard],
  },
  {
    path: 'setup/shifts',
    component: ShiftConfigurationComponent,
    canActivate: [MsalGuard],
    // canDeactivate: [CanDeactivateGuard],
  },
  ,
  {
    path: 'inventory/modulestocking',
    component: ModuleStockingDevanningComponent,
    canActivate: [MsalGuard, InvRolesGuard],
  },
  { path: 'parts-group', component: PartsGroupComponent },
  {
    path: 'inventory/parts-count',
    component: PartsCountComponent,
    canActivate: [MsalGuard,InvRolesGuard],
  },
  { path: 'add-edit-air-order', component: AddEditAirRecordComponent },
  { path: 'edit-air-order', component: EditFormComponent },
  {
    path: 'inventory/containertap',
    component: ContainerTapComponent,
    canActivate: [MsalGuard,InvRolesGuard],
  },
  {
    path: 'inventory/partsandinventorpolicies',
    component: ConfigurationPartsComponent,
    canActivate: [MsalGuard,InvRolesGuard],
    // canDeactivate: [CanDeactivateGuard],
  },

  {
    path: 'inventory/devan-history',
    component: DevanHistoryComponent,
    canActivate: [MsalGuard,InvRolesGuard],
  },
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: '**', component: HomeComponent, canActivate: [MsalGuard] },
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
